import React from 'react';
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { MenuItemHeader, MenuItemIcon, StyledMenuItem } from './styles';
import Tippy from '@tippyjs/react';
import { followCursor } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import 'tippy.js/themes/translucent.css';
import { smartRedirect } from 'components/SmartLink';

export interface NewMenuItemProps {
  title: string;
  path?: string;
  icon?: [IconPrefix, IconName];
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  isSidebarOpen?: boolean;
  isSubMenu?: boolean;
  isTeiaHeader?: boolean;
  isAccordion?: boolean;
  subItems?: Array<{ title: string; path: string; active?: boolean; disabled?: boolean }>;
}

export const NewMenuItem = ({
  active,
  disabled,
  path,
  icon,
  title,
  onClick,
  isSidebarOpen = true,
  isTeiaHeader = false,
  ...props
}: NewMenuItemProps) => {
  const collapsed = !isSidebarOpen;
  const collapsedLiStyle: React.CSSProperties | undefined = collapsed
    ? { display: 'flex', justifyContent: 'center', width: '100%' }
    : undefined;

  const handleClick = (e: React.MouseEvent) => {
    console.log("[handleClick] path:", path, "| disabled:", disabled);
    if (!path || path === 'undefined' || disabled) {
      console.log("[handleClick] early return — guard fired");
      e.preventDefault();
      return;
    }

    if (onClick) {
      onClick();
    }

    smartRedirect(e, path);
  };
  
  const menuItem = (
    <>
      <MenuItemHeader
        $collapsed={collapsed}
        to={`${disabled || !path || path === 'undefined' ? '#' : path}`}
        className={`${active ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
        onClick={handleClick}
      >
        {icon && <MenuItemIcon $collapsed={collapsed} icon={icon} />}
        {!collapsed && <span style={{ whiteSpace: 'nowrap' }}>{title}</span>}
      </MenuItemHeader>
    </>
  );

  return (
    <StyledMenuItem
      $collapsed={collapsed}
      className={`${active ? 'active' : ''}`}
      isTeiaHeader={isTeiaHeader}
    >
      {!isSidebarOpen ? (
        <Tippy
          content={title}
          followCursor={true}
          plugins={[followCursor]}
          animation="scale"
          arrow={false}
          maxWidth="20rem"
          theme="primary"
        >
          <li {...props} style={collapsedLiStyle}>
            {menuItem}
          </li>
        </Tippy>
      ) : (
        <li {...props} style={collapsedLiStyle}>
          {menuItem}
        </li>
      )}
    </StyledMenuItem>
  );
};


